import { Pipe, PipeTransform } from '@angular/core';
import { IllustrationImageName } from '@libs/shared/ui/illustration-image/illustration-image.component';

@Pipe({
  name: 'illustrationImage',
  standalone: true,
})
export class IllustrationImagePipe implements PipeTransform {
  transform(name: IllustrationImageName): unknown {
    return `assets/images/illustrations/${name}.svg`;
  }
}
